import React from 'react';
import ChalanUpdateAndReturnComponent from '../ChalanUpdateAndReturn/ChalanUpdateAndReturnComponent';

function StockReturn(props) {
  return (
    <>
      <ChalanUpdateAndReturnComponent
        is_stock_return={true}
        component_header_title="Stock return"
      />
    </>
  );
}

export default StockReturn;
